// The legacy .button look (components/buttons.scss).
const base =
  "min-hitbox-44 rounded border text-center font-sans font-bold focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-white focus-visible:outline-none contrast-more:focus-visible:ring-black forced-colors:focus-visible:outline-2 forced-colors:focus-visible:outline-offset-2 forced-colors:focus-visible:outline-solid"

const primary =
  "border-legacy-button-primary-border bg-legacy-button-primary text-white hover:bg-legacy-button-primary-hover hover:text-white active:bg-legacy-button-primary-active focus-visible:ring-legacy-button-primary-ring"

const secondary =
  "border-legacy-button-secondary-border bg-legacy-button-secondary text-gray-600 hover:bg-legacy-button-secondary-hover active:bg-legacy-button-secondary-active focus-visible:ring-legacy-button-secondary-ring"

const regular = "px-3 py-0.75 text-2xs"

// .button.large inside the profile sidebar's .profile-user-actions
const sidebar = "mb-3 box-border w-full px-4.5 py-3 text-sm leading-4"

export const primaryButton = `${base} ${primary} ${regular}`
export const secondaryButton = `${base} ${secondary} ${regular}`
export const sidebarPrimaryButton = `${base} ${primary} ${sidebar}`
